<template>
  <a-card class="Evaluationgame">
    <div style="margin-bottom: 15px;" @keyup.enter="searchList">
      <a-form-model layout="inline">
        <a-form-model-item label="游戏名称">
          <a-input allowClear placeholder="请输入游戏名称" :maxLength="20" v-model="search.Name"/>
        </a-form-model-item>
        <a-form-model-item label="版本名称">
          <a-input allowClear placeholder="请输入版本名称" :maxLength="20" v-model="search.versionName"/>
        </a-form-model-item>
        <a-form-model-item label="游戏类型">
          <a-select allowClear 
                    v-model="search.classifyTag"
                    placeholder="请选择游戏类型"
                    style="width:198px;">
            <a-select-option :value="1">商用</a-select-option>
            <a-select-option :value="4">科研</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="能力维度">
          <a-cascader v-model="selectId"
                      :options="options"
                      :load-data="loadData"
                      placeholder="请选择能力维度"
                      change-on-select
                      @change="onChange"/>
        </a-form-model-item>
		<a-form-model-item label="年龄段">
			<a-input-group compact>
				<a-input-number style=" width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="search.minAge"/>
				<a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled/>
				<a-input-number style="width: 100px; text-align: center;border-left:none;" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="150"  type="number" v-model="search.maxAge" />
			</a-input-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select allowClear
                    v-model="search.Enabled"
                    placeholder="请选择状态"
                    style="width:198px;">
            <a-select-option value="true">启用</a-select-option>
            <a-select-option value="false">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        
        <a-form-model-item >
          <a-button type="primary" @click="searchList">查询</a-button>
          <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`Content.Evaluationgame.Add`">
          <a-button @click="addEgame()" type="primary" icon="plus">添加游戏</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div>
      <a-table
        ref="myGamesTable"
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        rowKey="id"
        @expand="getVersion"
        @expandedRowsChange="expandedRowsChange"
        :expandedRowKeys="tableExpandedRowKeys"
        class="components-table-demo-nested"
        :pagination="{
          current: +search.PageIndex,
          pageSize: +search.PageSize,
          total: +total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="contentName" slot-scope="text,record">
          <div class="table_div">
            <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0 && text.enabled"/>
            {{text.contentName }}
          </div>
        </div>
        <div slot="classifyTag" slot-scope="text,record">
          {{text.classifyTag == 1 ? '商用' : text.classifyTag == 4 ? '科研' : '--' }}
        </div>
        <div slot="abilityTypeName" slot-scope="text,record">
          <div class="self_td" v-for="item in record.abilitys" :key="item.id">{{item.abilityTypeName}}</div>
        </div>
        <div slot="firstAbilityName" slot-scope="text,record">
          <div class="self_td" v-for="item in record.abilitys" :key="item.id">{{item.firstAbilityName}}</div>
        </div>
        <div slot="secondAbilityName" slot-scope="text,record">
          <div class="self_td" v-for="item in record.abilitys" :key="item.id">{{item.secondAbilityName}}</div>
        </div>
        <div slot="algorithmCode" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">{{item.algorithmCode}}</div>
        </div>
        <div slot="sampleSize" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">
              <a-button v-if="item.sampleSize" @click="toNormSetting(text, item)" type="link">
                  {{item.sampleSize}}
              </a-button>
          </div>
        </div>
        <div slot="estimatedTime" slot-scope="text,record">
          {{EstimatedTime(record.estimatedTime)}}
        </div>
        <div slot="status" slot-scope="text,record" v-auth="`Content.Evaluationgame.Enabled`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)"/>
        </div>
        <div slot="ages" slot-scope="text,record">
          {{record.minAge}} - {{record.maxAge}}
        </div>
        <div slot="action" slot-scope="text,record" class="action">
          <a @click="edit(record)" v-permission="`Content.Evaluationgame.Edit`">
            <a-icon type="edit"/> 编辑
          </a>
          <a @click="video(record)"><a-icon type="video-camera" /> 视频</a>
          <a-popconfirm title="确定删除？" @confirm="deleteEgame(record)" v-permission="`Content.Evaluationgame.Delete`">
            <a style="color: #f00;">
              <a-icon type="delete"/> 删除
            </a>
          </a-popconfirm>

        </div>
        <a-table
          slot="expandedRowRender"
          slot-scope="parentText,parentRecord"
          rowKey="id"
          :loading="parentText.childTableLoading"
          :columns="innerColumns"
          :data-source="parentText.childTableData"
          :pagination="false"
        >
          <div slot="version" slot-scope="text,record">
            <div class="table_div">
              {{ text.version }} 
              <span v-if="text.abnormalFlag > 0 && parentText.enabled && text.enabled" style="display: flex;align-items: center;margin-left:5px;color: #ff9904;">
                <a-icon type="exclamation-circle" theme="filled" class="table_icon"/>
                {{abnormalFlags[text.abnormalFlag] }}
              </span>
            </div>
          </div>
          <div slot="operation" class="table-operation" slot-scope="text,record">
            <span v-permission="`Content.Evaluationgame.Default`">
              <span v-if="text.enabled" style="color: #ff9904">默认版本</span>
              <a v-else @click="tableChildSetDefault(text,parentText)">设为默认</a>
            </span>
            <a v-permission="`Content.Evaluationgame.Preview`" style="margin-left:8px;" @click="viewGame(text)">预览</a>
          </div>
        </a-table>
      </a-table>
    </div>
    <!-- 关联视频 -->
    <a-modal v-model="relationModle.visible" title="关联视频" @ok="relationOk" width="50%">
        <a-form-model
            ref="ruleForm"
            :model="relationModle"
            :rules="relationRules"
            :label-col="{span:6}"
            :wrapper-col="{span:14}"
        >
            <a-form-model-item :ref="'Part' + (index + 1)" :label="'Part' + (index + 1)" class="part" v-for="(item,index) in relationModle.part" :key="index">
                <div class="inBox" @click="pick(item,index)">{{item.contentName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.firstAbilityName}}</div>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
    <!-- 选择视频 -->
    <a-modal v-model="pickModle.visible" title="选择视频" @ok="pickOk" width="60%">
        <a-form-model layout="inline">
            <a-form-model-item label="视频名称">
                <a-input placeholder="请输入视频名称" allow-clear :maxLength="20" v-model="pickModle.name" @keyup.enter="getList(1)"/>
            </a-form-model-item>
            <a-form-model-item label="一级能力">
                <a-tree-select
                    v-model="pickModle.firstAbilityId"
                    treeDefaultExpandAll
                    style="width:172px;"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    placeholder="选择所属模块"
                    allow-clear
                    >
                    <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
                        <template v-if="items.children">
                        <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                            <template v-if="item.children">
                            <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children"/>
                            </template>
                        </a-tree-select-node>
                        </template>
                    </a-tree-select-node>
                </a-tree-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="getModleList(1)">查询</a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table" style="margin-top:25px;">
            <a-table style="min-width: 800px;"
                :columns="videoColumns"
                ref="videoTable" 
                row-key="id"
                :row-selection="rowSelection"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="firstAbilityName" slot-scope="text,record">
                    <div v-for="item in record.abilitys" :key="item.id">
                        <span v-if="item.firstAbilityName == item.firstAbilityId"></span>
                        <span v-else>{{item.firstAbilityName}}</span>
                    </div>
                </div>
            </a-table>
        </div>
    </a-modal>
  </a-card>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import {EstimatedTime} from "@/utils/EstimatedTime";

const columns = [
  { title: '游戏名', scopedSlots: { customRender: 'contentName' }, width: 300},
  { title: '版本名称', dataIndex: 'versionName', width: 100},
  { title: '游戏类型', scopedSlots: { customRender: 'classifyTag' }},
  { title: '能力类型', class:'testClass', key: 'abilityTypeName', align:'center', scopedSlots: { customRender: 'abilityTypeName' }},
  { title: '一级能力', key: 'firstAbilityName', class:'testClass', align:'center', scopedSlots: { customRender: 'firstAbilityName' }},
  { title: '二级能力', key: 'secondAbilityName', class:'testClass', align:'center', scopedSlots: { customRender: 'secondAbilityName' }},
  { title: '算分码', class:'testClass', align:'center', scopedSlots: { customRender: 'algorithmCode' }},
  { title: '常模样本量', class:'testClass', align:'center', scopedSlots: { customRender: 'sampleSize' }},
  { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align:'center', key: 'time'},
  { title: '年龄段', scopedSlots: { customRender: 'ages' }, align:'center', key: 'createTime' },
  { title: '关联视频',dataIndex:'linkVideoCount', align:'center', key: 'linkVideoCount' },
  { title: '状态', key: 'status', align:'center', scopedSlots: { customRender: 'status' }},
  { title: '更新时间', dataIndex: 'updateTime', align:'center', key: 'updateTime' },
  { title: '操作', align:'center', scopedSlots: { customRender: 'action' }, width: 250},
];
const innerColumns = [
  { title: "游戏版本", scopedSlots: { customRender: "version" }, key: "version"},
  { title: "创建时间", dataIndex: "createTime", key: "createTime"},
  { title: "操作", scopedSlots: { customRender: "operation" }}
];
const videoColumns = [
    { title: '视频名称', key: "1", dataIndex:'contentName'},
    { title: '一级能力', key: "2", scopedSlots: {customRender: 'firstAbilityName'}},
    { title: '视频时长', key: "3", dataIndex:'endTime'},
    { title: '备注', key: "4", dataIndex:'remark'}
]
export default {
  name: "Evaluationgame",
  data() {
    return {
      EstimatedTime,
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      columns,
      innerColumns,
      innerData: [],
      total: 0,
      loading: true,
      chiloading: true,
      options: [],
      selectId: [],
      search: {
        PageIndex:1,
        PageSize:10,
        ContentType: 1,
        classifyTag:undefined,
        Name: "",
		versionName: undefined,
        AbilityTypeId: "",
        FirstAbilityId: "",
        SecondAbilityId: "",
        Enabled: undefined,
        minAge: undefined,
		maxAge: undefined,
      },
      tableExpandedRowKeys: [], //表格展开的行

        //关联视频
        relationModle:{
            visible:false,
            part:[
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
            ]
            
        },
        relationRules:{

        },
        //选择视频
        pickModle:{
            visible:false,
            name:'',
            firstAbilityId:''
        },
        videoColumns,
        tableRelevant: tableRelevant.call(this,this.getModleList),
        conselectedRow:[],
        currentPart:0,
        selectedRows:[],
        treeData:[],
        contentId:'',
        oldRadioValue: "",
        abnormalFlags:['','缺少算分码','缺少常模','常模不完整']
    };
  },
    created() {
        this.initSearch();
        this.getList();
        this.abilityTypeSelect(0);
    },
    watch:{
        "pickModle.visible"(now){
            if(!now){
                this.pickModle.name = ''
                this.pickModle.firstAbilityId = ''
            }
        }
    },
    computed: {
        rowSelection() {
            return {
                type:'radio',
                selectedRowKeys: this.conselectedRow,
                onChange: (selectedRowKeys, selectedRows) => {
                    if(selectedRowKeys[0] === this.conselectedRow[0]){
                        this.conselectedRow = [];
                    } else {
                        this.conselectedRow = selectedRowKeys;
                        this.selectedRows = selectedRows;
                    }
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: this.relationModle.part.filter((f, i) => i !== this.currentPart && f.id === record.id).length > 0,
                    },
                }),
            };
        }
    },
  methods: {
      initSearch(){
          this.search.Name = this.$route.query.Name;
          this.search.versionName = this.$route.query.versionName;
          this.search.Enabled = this.$route.query.Enabled;
          this.search.classifyTag = Number(this.$route.query.classifyTag) || undefined;
          this.search.PageIndex = Number(this.$route.query.PageIndex) || 1;
          this.search.PageSize = Number(this.$route.query.PageSize) || 10;
          this.search.AbilityTypeId = Number(this.$route.query.AbilityTypeId) || undefined;
          this.search.FirstAbilityId = Number(this.$route.query.FirstAbilityId) || undefined;
          this.search.SecondAbilityId = Number(this.$route.query.SecondAbilityId) || undefined;
          this.search.minAge = Number(this.$route.query.minAge) || undefined;
          this.search.maxAge = Number(this.$route.query.maxAge) || undefined;
          if (this.search.AbilityTypeId){
              this.selectId = [this.search.AbilityTypeId];
          }
          if (this.search.FirstAbilityId){
              this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId];
          }
          if (this.search.SecondAbilityId){
              this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId, this.search.SecondAbilityId];
          }
      },
      setQuery(){
          const query = {};
          for (const key in this.search) {
              if (this.search[key] && typeof this.search[key] !== "object") {
                  query[key] = this.search[key]
              }
          }
          this.$router.push({query})
      },
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      if (expandedRowKeys.length > 1) {
        this.tableExpandedRowKeys = [expandedRowKeys.pop()];
      } else {
        this.tableExpandedRowKeys = expandedRowKeys;
      }
    },
    //表格设为默认
    tableChildSetDefault(val,parentVal){
        this.$message.destroy();
        parentVal.childTableLoading = true;
        this.$http.updateVersionStatus({
            id: val.id,
            enabled: !val.enabled
        }).then(res => {
            parentVal.childTableLoading = false;
            this.$message.success(res.data.message);
            this.getVersion(true, parentVal);
        });
    },
      searchList() {
          this.search.PageIndex = 1
          this.loading = true
          this.getList();
      },
    viewGame(record){
      window.open(record.uri)
    },
    StatusChange(record) {
        const fn = () => {
            let formData = new FormData();
            formData.append("id", record.id);
            this.loading = true;
            this.$http.updatestatus(formData).then(res => {
                this.loading = false;
                this.$message.destroy();
                record.enabled = !record.enabled
                this.$message.success("修改成功");
            }).catch(err => {
                this.loading = false
            })
        };
        if (record.enabled) {
            this.$confirm({
                title: `确认禁用【${record.contentName}】`,
                content: "游戏禁用后，已配置的课程将移除该游戏且不可恢复，请谨慎操作",
                centered: true,
                onOk: fn
            });
            return
        }
        let formData = new FormData();
        formData.append("id", record.id);
        formData.append("enabled", false);
        this.loading = true;
        this.$http.contentCheckStatus(formData).then(res => {
            fn();
        });
    },
      toNormSetting(item, ability) {
          sessionStorage.setItem("currentName", item.contentName);
          this.$store.commit("content/setEvaluationGameInfo", {fullPath: this.$route.fullPath, ...item});
          const version = item.versions.filter(f => f.enabled)[0] || {};
          this.$router.push({
              path: "/content/NormSeting/NormComputeDetail",
              query: {
                  activeKey: 1,
                  type: "game",
                  id: ability.id,
                  version: version.version,
                  ContentAlgorithmCodeConfigId: ability.codeBindId,
                  abilityId: ability.abilityTypeId,
                  recordId: ability.normId,
                  pegetype: 'apply',
              }
          })
      },
    onChange(value) {
      console.log(value);
      this.search.AbilityTypeId = value[0];
      this.search.FirstAbilityId = value[1];
      this.search.SecondAbilityId = value[2];
      this.selectId = value;
    },
    loadData(selectedOptions) {
        return new Promise((resolve, reject) => {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            targetOption.children = [];
            let params = {
                pid: targetOption.id,
                abilityType:0
            };
            this.$http.abilitySelect(params).then(res => {
                targetOption.loading = false;
                targetOption.children = res.data.data.map(m => ({...m, value: m.id,label: m.name,isLeaf: m.levelNumber > 1}))
                this.options = [...this.options];
                resolve(targetOption.children)
            });
        })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType:0
      };
      this.$http.abilitySelect(params).then(res => {
          this.options = res.data.data;
          this.options.forEach(item => {
            item.value = item.id;
            item.label = item.name;
            item.isLeaf = false;
          });
          if (this.search.AbilityTypeId){
              this.loadData(this.options.filter(f => f.id === this.search.AbilityTypeId)).then(data => {
                  if (this.search.FirstAbilityId){
                      this.loadData(data.filter(f => f.id === this.search.FirstAbilityId))
                  }
              })
          }
      });
    },
    addEgame() {
          this.$store.commit("content/setEvaluationGameInfo", "");
      this.$router.push({
        path: "/content/evaluationgameSeting",
        query: {
          type: "add"
        }
      });
    },
    edit(record) {
        this.$store.commit("content/setEvaluationGameInfo", {fullPath: this.$route.fullPath, ...record})
        sessionStorage.setItem("evacurrentId", record.id);//id
        sessionStorage.setItem("currentName", record.contentName);//name
        sessionStorage.setItem("currentEnabled", record.enabled);//name
        this.$router.push({
          path: "/content/evaluationgameSeting",
          query: {
            type: "edit",
              id: record.id,
              contentName: record.contentName,
              versionName: record.versionName,
          }
        });
    },
    getList() {
        this.setQuery();
      this.$http.EGamegelist(this.search)
        .then(res => {
            this.tableExpandedRowKeys = [];
            this.dataSource = res.data.data.items.map(v => ({...v,childTableData: [], childTableLoading: false}));
            this.total = res.data.data.totalCount;
            this.loading = false;
        })
        .catch(err =>{
            this.loading = false
        })
    },
    getVersion(expanded, record) {
      if (expanded) {
        let params = {
          id: record.id
        };
          record.childTableLoading = true;
        this.$http.EGamegeVersion(params).then(res => {
            record.childTableLoading = false;
          record.childTableData = res.data.data;
        });
      }
    },
    deleteEgame(record) {
        this.$confirm({
            title: `确认删除【${record.contentName}】`,
            content: "游戏删除后所有相关数据都将删除且不可恢复，请谨慎操作",
            centered: true,
            onOk: () => {
                let formData = new FormData();
                formData.append("contentId", record.id);
                this.loading = true;
                this.$http.deleteEGamege(formData).then(res => {
                    this.loading = false;
                    this.getList();
                    this.$message.success("删除成功");
                });
            }
        });
    },
    onPageChange(page, size) {
      this.search.PageIndex = page;
      this.tableExpandedRowKeys = [];
      this.innerData = [];
      this.getList();
    },
    onSizeChange(page, size) {
      this.tableExpandedRowKeys = [];
      this.search.PageIndex = 1;
      this.search.PageSize = size;
      this.innerData = [];
      this.getList();
    },
    resetSearch(){
      this.search = {
        PageIndex:1,
        PageSize:10,
        ContentType: 1,
        Name: "",
          versionName: undefined,
        AbilityTypeId: "",
        FirstAbilityId: "",
        SecondAbilityId: "",
        Enabled: undefined
      }
      this.selectId = []
      this.getList()
    },

    getSelect() {
        let params = {
            isSelect:true,
            abilityType:0
        };
        this.$http.loadallsel(params)
        .then(res => {
            this.treeData = res.data.data
        });
    },
    video(text){
        this.relationModle = {
            visible:false,
            part:[
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
            ]   
        }
        this.getVideoInfo(text)
        this.contentId = text.id
        this.getSelect()
    },
    getVideoInfo(text){
        let params = {
            contentId:text.id
        }
        this.$http.GetContentRelevanceByContentId(params)
        .then(res => {
            const {data} = res.data;
            this.relationModle.visible = true
            if (data.length) {
                this.relationModle.part = this.relationModle.part.map((m ,i) => {
                    if(data[i]){
                        return {
                            contentName: data[i].linkContentName,
                            firstAbilityName: data[i].linkContentAbilityName,
                            id: data[i].linkContentId
                        }
                    }
                    return m
                })
            }
        })
        .catch(err =>{
            // this.loading = false
        })
    },
    getModleList(pageIndex){
        let params = {
            pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
            pageSize: this.tableRelevant.tablePagination.pageSize,
            name: this.pickModle.name,
            firstAbilityId: this.pickModle.firstAbilityId,
            ContentType:4,
            ScientificName:'游戏指导'
        }
        this.$http.EGamegelist(params)
        .then(res => {
            this.tableExpandedRowKeys = [];
             res.data.data.items.forEach(v=>{
                v.firstAbilityName = v.abilitys.length ? v.abilitys[0].firstAbilityName : ''
            })
            this.tableRelevant.tableDataSource = res.data.data.items
            this.tableRelevant.tablePagination.total = res.data.data.totalCount;
            this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
        })
        .catch(err =>{
            this.loading = false
        })
    },
    // 关联视频
    relationOk(){
        let params = {
            contentId:this.contentId,
            links:[]
        }
        let arr = []
        console.log(this.relationModle.part)
        this.relationModle.part.forEach((v,i)=>{
            let str = {
                linkContentId:'',
                relevanceType:1,
                sortIndex:i+1,
            }
            if(v.id){
                str.linkContentId = v.id
                arr.push(str)
            }
        })
        params.links = arr
        console.log(params)
        // return
        this.$http.RelevanceVideo(params)
        .then(() => {
            this.$message.success('关联成功')
            this.relationModle = {
                visible:false,
                part:[
                    {contentName:'',firstAbilityName:''},
                    {contentName:'',firstAbilityName:''},
                    {contentName:'',firstAbilityName:''},
                ]
            }
        })
        .catch(err =>{
            this.$message.error('系统异常')
        })
    },
    pick(item,index){
        this.conselectedRow = []
        this.pickModle.visible = true
        this.currentPart = index
        this.conselectedRow.push(this.relationModle.part[index].id)
        this.getModleList(1);
        this.$nextTick(() => {
           this.$refs.videoTable.$el.addEventListener("click", this.cancelTableRadio, true);
        })
    },
    //选择视频
    pickOk(){
        if(!this.relationModle.part.filter(f => f.id).length){
            if(!this.selectedRows.length){
                this.$message.destroy();
                this.$message.error('请选择视频')
                return
            }
        }
        

        if(this.selectedRows.length){
            this.relationModle.part[this.currentPart] = this.selectedRows[0]
            this.pickModle.visible = false
        }else{
            this.relationModle.part[this.currentPart] = {contentName:'',firstAbilityName:''}
            this.pickModle.visible = false
        }
        this.selectedRows = []
    },
    cancelTableRadio(ev){
        const e = ev || event;
        if(typeof e.target.checked === "boolean"){
            if(this.oldRadioValue == e.target.value){
                this.conselectedRow = [];
                this.selectedRows = [];
            } else {
                this.oldRadioValue = e.target.value;
            }
            //e.target.checked = !e.target.checked
        }
    }
  }
};
</script>

<style scoped>
.table_div{
  display: flex;
  align-items: center;
}
.table_icon{
  color:#ff9904;
  font-size:24px;
  margin-right: 5px;
}
.Evaluationgame >>> .standard-table .alert {
  display: none !important;
}

.Evaluationgame >>> .searchForm {
  display: flex;
}
.Evaluationgame >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
.sbtn{
    display: flex;
    align-items: center;
    height: 40px;
  }
</style>
<style lang="less" scoped>
/deep/ .ant-table-tbody .testClass{
  padding: 0 !important;
}
.self_td{
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
.inBox{
    height:32px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor:pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;
}
.inBox:hover{
    border-color: #36cfc9;
    border-right-width: 1px !important;
}
.part{
    display:flex;
    align-items: center;
}
</style>